module.exports = require('./lib/node_cache');


//////////////////
// WEBPACK FOOTER
// ./~/node-cache/index.js
// module id = 4050
// module chunks = 64